// Copyright (c) StrangeBee 2024

import { classList } from '@Helpers/className';
import { Input } from 'antd';
import { TextAreaProps } from 'antd/lib/input';
import React, { ReactElement } from 'react';
import { Helper } from './Helper';

import './THTextArea.scss';

interface THTextAreaProps extends TextAreaProps {
    borderless?: boolean;
    resize?: boolean;
}

export const THTextArea = ({
    borderless = false,
    className,
    autoComplete,
    resize = true,
    ...props
}: THTextAreaProps): ReactElement => (
    <Input.TextArea
        className={classList('th-text-area', className, { 'no-border': borderless, 'no-resize': !resize })}
        size="large"
        autoComplete={autoComplete || 'off'}
        {...props}
    />
);

THTextArea.Helper = Helper;
